/**
 * 
 */
(function() {
  'use strict';
  angular.module('cbl.insuranceloanpmi.mf').factory('CreasModelFctr', function() {
    var fidoNonOperativo = function() {
      return {
        idFidoNonOperativoPMI: null,
        importoDisponibile: null,
        importoErogato: null,
        stato: null,
        dataApertura: null,
        dataRinnovo: null,
        dataFineValidita: null,
        numPraticaEffettiva: null,
        contoAppoggio: null,
        idPraticaFinanziamentoMultiPolizzaPMI: null,
        fasciaFido: null
      };
    };

    var prodotto = function() {
      return {
        idProdotto: null,
        idProdottoCPT: null,
        codiceProdottoCPT: null,
        versioneProdottoCPT: null,
        convenzione: null,
        descrizione: null,
        codiceProdottoEsterno: null
      };
    };

    var intestatario = function() {
      return {
        formaCostitutiva: '',
        intestazione: '',
        ndg: '',
        idAnagrafica: '',
        relazioniAnagrafiche: []
      };
    };

    var pratica = function() {
      return {
        idPraticaFinanziamentoMultiPolizzaPMI: null,
        elencoFinanziamentoMultiPolizzaPMI: [],
        fidoNonOperativo: fidoNonOperativo(),
        prodotto: prodotto(),
        intestatario: intestatario(),
        idPratica: '',
        inserimento: null,
        ultimaModifica: null,
        specializzazione: null,
        stato: null,
        tipo: null,
        idMacropratica: null,
        canale: null,
        filiale: null,
        codicePromotore: null,
        incaricato: null,
        dataPresaInCarico: null,
        step: null,
        hidden: null
      };
    };
    return {
      fidoNonOperativo: fidoNonOperativo,
      prodotto: prodotto,
      intestatario: intestatario,
      pratica: pratica
    };
  });
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/servicesUtilities/creasModelFctr.js
// module id = 38
// module chunks = 0 1